import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { switchMap } from 'rxjs';

// A JSON string value that is a date without time, e.g. "2027-06-01".
const dateOnlyValue = /"(\d{4}-\d{2}-\d{2})"/g;

/**
 * The backend sends dates without time (DateOnly) as "yyyy-MM-dd". The generated clients parse them with new Date(...), which
 * reads date-only strings as UTC midnight: west of UTC that is the previous day, and saving a dialog stores that day.
 * Date-time strings without an offset are local time, so appending the time makes them parse as local midnight of the same day.
 */
export const dateOnlyInterceptor: HttpInterceptorFn = (req, next) =>
  next(req).pipe(
    switchMap(async (event) => {
      if (!(event instanceof HttpResponse) || !(event.body instanceof Blob) || !event.body.type.includes('json')) {
        return event;
      }

      const json = await event.body.text();
      return event.clone({ body: new Blob([json.replace(dateOnlyValue, '"$1T00:00:00"')], { type: event.body.type }) });
    }),
  );
